import React, { useRef, useEffect, useState } from 'react';
import { AssessmentDashboardStage } from '../../../api/models/assessment-dashboard-stage';

interface StageMasteryChartProps {
	title: string;
	stageMastery?: AssessmentDashboardStage[];
}

const StageMasteryChart: React.FC<StageMasteryChartProps> = ({ title, stageMastery }) => {
	// State to store the height of Chart Label
	const [lineHeight, setLineHeight] = useState<number | undefined>(undefined);

	useEffect(() => {
		const numberOfStageRows = stageMastery?.length || 0;
		const barHeight = 28;
		const barGap = 8;
		const height = numberOfStageRows * (barHeight + barGap);

		setLineHeight(height);
	}, [stageMastery]);

	return (
		<article className="assessment-stage-mastery-card">
			<p className="h3 text-shades-800 text-center mb-4">{title}</p>

			<p className="body-small text-shades-500 text-center mb-2 fw-semibold"> No. of students</p>

			{/* CHART */}
			<div className="benchmark-chart-wrapper">
				<div className="percentage-row">
					<div className="stage-mastery-name"></div>

					<div className="percentage-labels-row">
						<span className="body-tiny text-shades-500">0%</span>
						<span className="body-tiny text-shades-500 transform-text">50%</span>
						<span className="body-tiny text-shades-500 transform-text">100%</span>

						<span className="line-50" style={lineHeight !== undefined ? { height: `${lineHeight}px` } : {}}></span>
					</div>
				</div>

				{stageMastery?.length &&
					stageMastery?.map((stage, stageIndex) => {
						return (
							<div className="chart-stage-row mb-2" key={`stage-mastery-chart-row-${stageIndex}`}>
								<div className={`stage-mastery-name stage-${stage.name}`}>{stage.name}</div>

								<div className="stage-mastery-chart-wrapper">
									<div className="stage-mastery-chart-bar" style={{ width: `${stage.percentage}%` }}>
										{stage.count && stage.count > 0 ? (
											<div className="label-group">
												<span className="label label-total">{stage.count}</span>
												<span className="label label-percentage">
													(
													{stage.percentage !== undefined
														? Number.isInteger(stage.percentage)
															? stage.percentage
															: stage.percentage.toFixed(2)
														: ''}
													%)
												</span>
											</div>
										) : null}
									</div>
								</div>
							</div>
						);
					})}
			</div>
		</article>
	);
};

export default StageMasteryChart;
